import React from 'react'
import { Input } from '../ui'

export type PaymentDatePeriodFilterProps = {
  from: string
  to: string
  onFromChange: (value: string) => void
  onToChange: (value: string) => void
  onChange?: () => void
}

export function PaymentDatePeriodFilterFields({
  from,
  to,
  onFromChange,
  onToChange,
  onChange,
}: PaymentDatePeriodFilterProps) {
  const bump = onChange ?? (() => {})
  return (
    <>
      <div
        className="flex min-w-0 items-center gap-2"
        title="Filtra pela coluna payment_date (data de pagamento informada manualmente)"
      >
        <span className="shrink-0 text-xs font-medium text-gray-600 dark:text-gray-400 sm:text-sm">Pagamento de</span>
        <Input
          type="date"
          className="min-w-0 flex-1"
          aria-label="Pagamento de"
          value={from}
          onChange={(e) => {
            onFromChange(e.target.value)
            bump()
          }}
        />
      </div>
      <div
        className="flex min-w-0 items-center gap-2"
        title="Filtra pela coluna payment_date (data de pagamento informada manualmente)"
      >
        <span className="shrink-0 text-xs font-medium text-gray-600 dark:text-gray-400 sm:text-sm">Pagamento até</span>
        <Input
          type="date"
          className="min-w-0 flex-1"
          aria-label="Pagamento até"
          value={to}
          onChange={(e) => {
            onToChange(e.target.value)
            bump()
          }}
        />
      </div>
    </>
  )
}
